import React from 'react';

/**
 * Consistency Wordmark
 * Text: "Consistency" - Capital C, lowercase remaining
 * Gradient: blue → cyan → green flowing horizontally
 */
export default function ConsistencyWordmark({ height = 32, className = '' }) {
  return (
    <svg
      height={height}
      viewBox="0 0 280 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ width: 'auto' }}
    >
      <defs>
        <linearGradient id="wordmarkGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#3A7BFF" />
          <stop offset="50%" stopColor="#39E6C8" />
          <stop offset="100%" stopColor="#29E07F" />
        </linearGradient>
      </defs>
      <text
        x="0"
        y="45"
        fontFamily="Inter, system-ui, -apple-system, sans-serif"
        fontSize="48"
        fontWeight="500"
        fill="url(#wordmarkGradient)"
        letterSpacing="-0.5"
      >
        Consistency
      </text>
    </svg>
  );
}
